exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-head .btn.add-product { \n\tcolor: #fff; \n\tdisplay: -webkit-box; \n\tdisplay: -ms-flexbox; \n\tdisplay: flex; \n\tfont-size: 14px;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center; \n\twhite-space: nowrap;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/vendor-list/vendor-list.component.css
// module id = ../../../../../src/app/mnt-invoices/vendor-list/vendor-list.component.css
// module chunks = common